import React, { useContext, useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Breadcrumb } from 'react-bootstrap';
import { useLocation, useNavigate } from "react-router-dom";
import './ManagerPractices.scss';
import Axios from 'utility/Axios';
import configURL from 'config/config';
import { toast } from 'react-toastify';
import AppContext from 'store/AppContext';


const CustomCss = () => {
    const navigate = useNavigate();
    const [customCss, setCustomCss] = useState("");
    const { EziLoader } = useContext(AppContext);
    const location = useLocation()
    const companyId = location.state.companyData?.account_id;

    const handleSaveCustomCss = () => {
        EziLoader.show();
        let formData = new FormData();
        formData.append("account_id", companyId);
        formData.append("custom_css", customCss === "" ? null : JSON.stringify(customCss));
        Axios.post(configURL.store_or_update_company_data, formData).then(response => {
            if (response.data.success !== undefined && response.data.success === true) {
                EziLoader.hide();
                toast.success(response.data.message || "Custom Css updated !")
            }
        }).catch(err => {
            console.log(err);
            EziLoader.hide();
        })
    }

    const getCustomCss = () => {
        let formData = new FormData();
        formData.append("account_id", companyId);
        Axios.post(configURL.get_store_or_update_company_data, formData).then(response => {
            if (response.data.success !== undefined && response.data.success === true) {
                let customCssRaw = response?.data?.data?.custom_css;
                let Data = (customCssRaw !== null && customCssRaw !== "null" && customCssRaw !== "")
                    ? JSON.parse(customCssRaw)
                    : null; setCustomCss(Data);
            }
        }).catch(err => {
            console.log(err);
        })
    }

    useEffect(() => {
        getCustomCss();
        // eslint-disable-next-line
    }, [])

    return (
        <React.Fragment>
            <section className="Page-ManagerPractices Page-CustomCss" >
                <div className="breadcrumb_ezi">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => navigate("/dashboard")}>Dashboard</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={() => navigate("/companies")}>Companies</Breadcrumb.Item>
                        <Breadcrumb.Item>Custom Css</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="column-header">
                        <h1 className="page-heading">Custom Css</h1>
                        <div className="column-header-btn">
                            <button type="button" className="btn-ripple add-new" onClick={() => handleSaveCustomCss()}>Save</button>
                        </div>
                    </div>
                </div>
                <div className="custom_css">
                    <textarea placeholder={"Add Custom Css here..."} value={customCss} type="text" onChange={event => setCustomCss(event.target.value)}></textarea>
                </div>
            </section>
        </React.Fragment>
    )
}
/* eslint-enable */
const mapStateToProps = state => {
    return {
        vendorInfo: state.app.vendorInfo
    }
}
export default connect(mapStateToProps)(CustomCss);